<template>
  <Header />
  <SideBar />
  <slot></slot>
  <Footer />
</template>

<script>


export default {

}
</script>

